import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// ?safe&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_tai_chi_walking_fem_v2_ai_coach~1
			funnel: {
				id: 'ob-female-tai-chi-walking-v2-ai-coach',
				locale: ['en'],
			},
		},
	},
]

export default config
